import { CSSProperties } from 'react';
import { useRouter } from 'next/router';
import { t } from 'i18next';
// components
import { ExButton } from '@commons/EXComponentsLibrary';
import { MessageWrapperWithFadeOut } from '@commons/components/MessageWrapperWithFadeOut';
// utisl && hooks
import { Role } from 'common/types';
import { useUser } from 'utils/hooks';
// styles
import styles from './AgreementExpiredMessage.module.css';

const AgreementExpiredMessage = ({ handleRemoveAlert, agreement, setVisibleAlerts, idDeleted }) => {
    const {
        query: { clientId },
        push,
    } = useRouter();

    const { user } = useUser({});

    const drugManufacturersText = agreement.drug_manufacturers
        .map((drugManufacturer) => drugManufacturer.name)
        .join(', ');

    const getStyles = (): CSSProperties => {
        return {
            height: 70,
            border: '1px solid var(--Semantic-Warning-100, #FFEA9F)',
            background: 'var(--Semantic-Warning-50, #FFF9E6)',
            boxShadow: '0px 10px 15px -3px rgba(64, 67, 91, 0.10), 0px 4px 6px -2px rgba(64, 67, 91, 0.05)',
        };
    };

    const isBuyer = user?.role_id === Role.Buyer;

    return (
        <MessageWrapperWithFadeOut
            customStyles={getStyles()}
            fadeOut={idDeleted?.includes(agreement.notification_type_id)}
            handleFinishFadeOut={() =>
                setVisibleAlerts((prev) =>
                    prev.filter((item) => item.notification_type_id !== agreement.notification_type_id),
                )
            }
        >
            <div className={styles['wrapper-principal-content']}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M2.72479 21C2.54146 21 2.37479 20.9542 2.22479 20.8625C2.07479 20.7708 1.95812 20.65 1.87479 20.5C1.79146 20.35 1.74562 20.1875 1.73729 20.0125C1.72896 19.8375 1.77479 19.6667 1.87479 19.5L11.1248 3.5C11.2248 3.33333 11.354 3.20833 11.5123 3.125C11.6706 3.04167 11.8331 3 11.9998 3C12.1665 3 12.329 3.04167 12.4873 3.125C12.6456 3.20833 12.7748 3.33333 12.8748 3.5L22.1248 19.5C22.2248 19.6667 22.2706 19.8375 22.2623 20.0125C22.254 20.1875 22.2081 20.35 22.1248 20.5C22.0415 20.65 21.9248 20.7708 21.7748 20.8625C21.6248 20.9542 21.4581 21 21.2748 21H2.72479ZM11.9998 18C12.2831 18 12.5206 17.9042 12.7123 17.7125C12.904 17.5208 12.9998 17.2833 12.9998 17C12.9998 16.7167 12.904 16.4792 12.7123 16.2875C12.5206 16.0958 12.2831 16 11.9998 16C11.7165 16 11.479 16.0958 11.2873 16.2875C11.0956 16.4792 10.9998 16.7167 10.9998 17C10.9998 17.2833 11.0956 17.5208 11.2873 17.7125C11.479 17.9042 11.7165 18 11.9998 18ZM11.9998 15C12.2831 15 12.5206 14.9042 12.7123 14.7125C12.904 14.5208 12.9998 14.2833 12.9998 14V11C12.9998 10.7167 12.904 10.4792 12.7123 10.2875C12.5206 10.0958 12.2831 10 11.9998 10C11.7165 10 11.479 10.0958 11.2873 10.2875C11.0956 10.4792 10.9998 10.7167 10.9998 11V14C10.9998 14.2833 11.0956 14.5208 11.2873 14.7125C11.479 14.9042 11.7165 15 11.9998 15Z"
                        fill="#FFC700"
                    />
                </svg>

                <div className={styles['messageContent']}>
                    <p className={styles['title']}>
                        {agreement.notification_type_id === 2
                            ? t('agreements.alert.title.now', {value: drugManufacturersText}).replace(/\.$/, '')
                            : t('agreements.alert.title.last', {value: drugManufacturersText}).replace(/\.$/, '')}
                    </p>
                    {!isBuyer && agreement.notification_type_id === 1 && <p className={styles['subtitle']}>{t('agreements.alert.subtitle.last')}</p>}
                </div>
            </div>

            <div className={styles['actions']}>
                {!isBuyer && (
                    <ExButton appearance="link" size="lg" onClick={handleRemoveAlert}>
                        {t('agreements.alert.button.omit')}
                    </ExButton>
                )}

                <ExButton
                    appearance="primary"
                    size="lg"
                    className={styles['button']}
                    onClick={() => {
                        handleRemoveAlert();
                        if(!isBuyer) {
                            push(`/${clientId}/settings/trade-agreements`);
                        }
                    }}
                >
                    {isBuyer ? t('agreements.alert.button.ok') : t('agreements.alert.button.update')}
                </ExButton>
            </div>
        </MessageWrapperWithFadeOut>
    );
};

export default AgreementExpiredMessage;
